module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_07.6d595a22.svg";